"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSharedAccessArguments = exports.removeSharedAccessOptions = void 0;
exports.removeSharedAccessOptions = [
    {
        name: "users",
        type: "array",
        description: "Select users to remove access",
        required: true,
        skipValidation: true,
    },
];
exports.removeSharedAccessArguments = [];
//# sourceMappingURL=removeSharedAccessOptions.js.map